export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": "non-auth.vue",
      "title": "Green Medicine Works",
      "description": "Science Based Encyclopedia of Nutrition and Natural Health"
    }
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/about',
    name: '/about',
    component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/about.vue'),
    /* no children */
    meta: {
      "layout": "non-auth.vue"
    }
  },
  {
    path: '/activation',
    /* internal name: '/activation' */
    /* no component */
    children: [
      {
        path: '',
        name: '/activation/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/activation/index.vue'),
        /* no children */
        meta: {
          "layout": "non-auth.vue"
        }
      }
    ],
  },
  {
    path: '/advance-search',
    /* internal name: '/advance-search' */
    /* no component */
    children: [
      {
        path: '',
        name: '/advance-search/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/advance-search/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/annotations',
    /* internal name: '/annotations' */
    /* no component */
    children: [
      {
        path: '',
        name: '/annotations/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/annotations/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: 'login',
        /* internal name: '/auth/login' */
        /* no component */
        children: [
          {
            path: '',
            name: '/auth/login/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/auth/login/index.vue'),
            /* no children */
            meta: {
              "layout": "auth",
              "title": "Login"
            }
          }
        ],
      },
      {
        path: 'signup',
        /* internal name: '/auth/signup' */
        /* no component */
        children: [
          {
            path: '',
            name: '/auth/signup/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/auth/signup/index.vue'),
            /* no children */
            meta: {
              "layout": "auth",
              "title": "Signup"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/bookmark',
    /* internal name: '/bookmark' */
    /* no component */
    children: [
      {
        path: '',
        name: '/bookmark/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/bookmark/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/bookmarks',
    /* internal name: '/bookmarks' */
    /* no component */
    children: [
      {
        path: '',
        name: '/bookmarks/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/bookmarks/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/bot',
    /* internal name: '/bot' */
    /* no component */
    children: [
      {
        path: '',
        name: '/bot/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/bot/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/categories',
    /* internal name: '/categories' */
    /* no component */
    children: [
      {
        path: '',
        name: '/categories/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/categories/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/content',
    /* internal name: '/content' */
    /* no component */
    children: [
      {
        path: '',
        name: '/content/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/content/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      },
      {
        path: ':id',
        /* internal name: '/content/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/content/[id]/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/content/[id]/index.vue'),
            /* no children */
            meta: {
              "layout": "authenticated"
            }
          }
        ],
      },
      {
        path: 'viewall',
        /* internal name: '/content/viewall' */
        /* no component */
        children: [
          {
            path: '',
            name: '/content/viewall/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/content/viewall/index.vue'),
            /* no children */
            meta: {
              "layout": "authenticated"
            }
          }
        ],
      },
      {
        path: 'viewfull',
        /* internal name: '/content/viewfull' */
        /* no component */
        children: [
          {
            path: '',
            name: '/content/viewfull/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/content/viewfull/index.vue'),
            /* no children */
            meta: {
              "layout": "authenticated"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/error',
    /* internal name: '/error' */
    /* no component */
    children: [
      {
        path: '',
        name: '/error/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/error/index.vue'),
        /* no children */
        meta: {
          "layout": "non-auth.vue"
        }
      }
    ],
  },
  {
    path: '/forgot',
    /* internal name: '/forgot' */
    /* no component */
    children: [
      {
        path: 'password',
        /* internal name: '/forgot/password' */
        /* no component */
        children: [
          {
            path: '',
            name: '/forgot/password/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/forgot/password/index.vue'),
            /* no children */
            meta: {
              "layout": "non-auth.vue"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/history',
    /* internal name: '/history' */
    /* no component */
    children: [
      {
        path: '',
        name: '/history/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/history/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/illegal',
    /* internal name: '/illegal' */
    /* no component */
    children: [
      {
        path: '',
        name: '/illegal/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/illegal/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/index-page',
    /* internal name: '/index-page' */
    /* no component */
    children: [
      {
        path: '',
        name: '/index-page/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/index-page/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/limit',
    /* internal name: '/limit' */
    /* no component */
    children: [
      {
        path: '',
        name: '/limit/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/limit/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/navigator',
    /* internal name: '/navigator' */
    /* no component */
    children: [
      {
        path: '',
        name: '/navigator/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/navigator/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/notes',
    /* internal name: '/notes' */
    /* no component */
    children: [
      {
        path: '',
        name: '/notes/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/notes/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/plans',
    /* internal name: '/plans' */
    /* no component */
    children: [
      {
        path: '',
        name: '/plans/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/plans/index.vue'),
        /* no children */
        meta: {
          "layout": "non-auth.vue"
        }
      },
      {
        path: ':id',
        /* internal name: '/plans/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/plans/[id]/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/plans/[id]/index.vue'),
            /* no children */
            meta: {
              "layout": "non-auth.vue"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/preview',
    /* internal name: '/preview' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: '/preview/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/preview/[id]/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/preview/[id]/index.vue'),
            /* no children */
            meta: {
              "layout": "public"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/privacy',
    /* internal name: '/privacy' */
    /* no component */
    children: [
      {
        path: 'policy',
        /* internal name: '/privacy/policy' */
        /* no component */
        children: [
          {
            path: '',
            name: '/privacy/policy/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/privacy/policy/index.vue'),
            /* no children */
            meta: {
              "layout": "non-auth.vue"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/profile',
    /* internal name: '/profile' */
    /* no component */
    children: [
      {
        path: '',
        name: '/profile/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/profile/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/pubmed-ai',
    /* internal name: '/pubmed-ai' */
    /* no component */
    children: [
      {
        path: '',
        name: '/pubmed-ai/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/pubmed-ai/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/register',
    /* internal name: '/register' */
    /* no component */
    children: [
      {
        path: 'trial',
        /* internal name: '/register/trial' */
        /* no component */
        children: [
          {
            path: '',
            name: '/register/trial/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/register/trial/index.vue'),
            /* no children */
            meta: {
              "layout": "public"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/search',
    /* internal name: '/search' */
    /* no component */
    children: [
      {
        path: '',
        name: '/search/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/search/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: '',
        name: '/settings/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/settings/index.vue'),
        /* no children */
        meta: {
          "layout": "authenticated"
        }
      }
    ],
  },
  {
    path: '/subscription',
    /* internal name: '/subscription' */
    /* no component */
    children: [
      {
        path: '',
        name: '/subscription/',
        component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/subscription/index.vue'),
        /* no children */
        meta: {
          "layout": "non-auth.vue"
        }
      }
    ],
  },
  {
    path: '/success',
    /* internal name: '/success' */
    /* no component */
    children: [
      {
        path: 'reset',
        /* internal name: '/success/reset' */
        /* no component */
        children: [
          {
            path: '',
            name: '/success/reset/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/success/reset/index.vue'),
            /* no children */
            meta: {
              "layout": "non-auth.vue"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/terms',
    /* internal name: '/terms' */
    /* no component */
    children: [
      {
        path: 'service',
        /* internal name: '/terms/service' */
        /* no component */
        children: [
          {
            path: '',
            name: '/terms/service/',
            component: () => import('/Volumes/OtherStuff/Development/In-Tele-Health-America-LLC/GMW/gmw/src/pages/terms/service/index.vue'),
            /* no children */
            meta: {
              "layout": "non-auth.vue"
            }
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

